import styled from "styled-components";

import { Constants } from "../../Assets/Constants";

export default styled.main`
  margin-left: ${Constants.sidebarWidth};
  padding: 0 ${Constants.innerPadding} ${Constants.innerPadding}
    ${Constants.innerPadding};
`;
